import * as d3Scale from 'd3-scale';

export default {
  computed: {
    left () {
      return this.config.yAxisPosition === 'left'
        ? +this.config.globalMarginLeft + +this.config.yAxisWidth
        : +this.config.globalMarginLeft;
    },
    right () {
      return this.config.yAxisPosition === 'right'
        ? +this.config.globalMarginRight + +this.config.yAxisWidth
        : +this.config.globalMarginRight;
    },
    top () {
      let top = +this.config.globalMarginTop;
      if (this.config.xAxisPosition === 'top')
        top = +top + +this.config.xAxisHeight;
      if (this.config.legendPosition === 'top')
        top = +top + +this.config.legendHeight;
      return top;
    },
    canvasSize () {
      return {
        width: this.width - this.left - this.right,
        height: this.height -
          this.config.xAxisHeight -
          this.config.legendHeight -
          this.config.globalMarginTop -
          this.config.globalMarginBottom,
      };
    },
    scaleY () {
      let scale = d3Scale
        .scaleLinear ()
        .domain ([this.maxMinY[0].min, this.maxMinY[0].max])
        .range ([this.top + this.canvasSize.height, this.top]);
      return scale;
    },
    scaleX () {
      let scale = d3Scale
        .scaleLinear ()
        .domain ([this.maxMinX.min, this.maxMinX.max])
        .range ([this.left, this.left + this.canvasSize.width]);
      return scale;
    },
  },
};
